module.exports = __webpack_public_path__ + "static/media/brand-reg-image.9388c17b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-reg-image.png
// module id = 275
// module chunks = 2